const translations = {
  fr: {
    home_promos: "Promotions du moment",
    catalogue_promo_only: "Promos uniquement",
    promo_until: "Jusqu'au {date}",
    forgot_admin_desc_failed: "L'envoi de l'e-mail n'a pas abouti : notre équipe a été prévenue et vous enverra un mot de passe temporaire par WhatsApp. Vous pouvez aussi nous écrire directement :",
    login_remember: "Rester connecté 30 jours",
    register_email_required: "Obligatoire — permet de récupérer votre compte en cas d'oubli",
    forgot_desc: "Entrez votre numéro de téléphone ou votre e-mail. Si un e-mail est associé à votre compte, vous recevrez un lien pour choisir un nouveau mot de passe ; sinon notre équipe vous enverra un accès temporaire par WhatsApp.",
    forgot_identifier: "Téléphone ou e-mail",
    forgot_submit: "Récupérer mon compte",
    forgot_error: "Impossible de traiter la demande, réessayez.",
    forgot_email_title: "E-mail envoyé",
    forgot_email_desc: "Un lien de réinitialisation a été envoyé à {email}. Il est valable 1 heure.",
    forgot_email_hint: "Pensez à vérifier vos courriers indésirables.",
    forgot_admin_title: "Demande transmise",
    forgot_admin_desc: "Aucun e-mail n'est associé à votre compte : notre équipe a été prévenue et vous enverra un mot de passe temporaire par WhatsApp. Vous pouvez aussi nous écrire directement :",
    forgot_none_title: "Compte introuvable",
    forgot_none_desc: "Nous n'avons trouvé aucun compte avec cet identifiant. Contactez-nous sur WhatsApp, nous retrouverons votre compte ensemble.",
    reset_title: "Nouveau mot de passe",
    reset_desc: "Choisissez un nouveau mot de passe (6 caractères minimum).",
    reset_new_password: "Nouveau mot de passe",
    reset_confirm_password: "Confirmer le mot de passe",
    reset_submit: "Enregistrer",
    reset_mismatch: "Les mots de passe ne correspondent pas",
    reset_error: "Lien invalide ou expiré",
    reset_invalid: "Ce lien est invalide. Refaites une demande depuis « Mot de passe oublié ».",
    reset_done_title: "Mot de passe modifié",
    reset_done_desc: "Vous pouvez maintenant vous connecter. Redirection…",
    nudge_email_title: "Sécurisez votre compte",
    nudge_email_desc: "Ajoutez votre adresse e-mail : elle vous permettra de récupérer votre compte vous-même en cas de mot de passe oublié.",
    nudge_later: "Plus tard",
    nudge_save: "Enregistrer",
    nudge_email_saved: "E-mail enregistré",
    nudge_email_error: "Adresse e-mail invalide",
    nudge_temp_password: "Vous utilisez un mot de passe temporaire. Choisissez-en un nouveau pour sécuriser votre compte.",
    nudge_change_now: "Changer maintenant",
    nav_preorder: "Précommande",
    status_preorder: "Précommande (arrivage à venir)",
    product_preorder_badge: "Précommande",
    product_preorder_link: "Ce produit est en arrivage — précommandez-le",
    preorder_kicker: "Arrivages à venir",
    preorder_title: "Précommandes",
    preorder_subtitle: "Nouveautés et retours en stock attendus chez nos fournisseurs. Réservez vos pièces dès maintenant : elles vous seront livrées dès réception, à la date indiquée.",
    preorder_empty: "Aucun arrivage en précommande pour le moment. Revenez bientôt !",
    preorder_expected: "Arrivée prévue le",
    preorder_available: "{count} pièce(s) précommandable(s)",
    preorder_sold_out: "Quantité épuisée",
    preorder_items: "{count} article(s) en précommande",
    preorder_continue: "Précommander",
    preorder_login_required: "Connectez-vous pour valider votre précommande.",
    preorder_back: "Retour",
    preorder_submit: "Envoyer ma précommande",
    preorder_summary: "Votre précommande",
    preorder_delivery_note: "Livraison prévue à partir du {date}, dès réception de la marchandise. Aucun paiement maintenant.",
    preorder_error: "La précommande n'a pas pu être enregistrée.",
    preorder_success_title: "Précommande enregistrée",
    preorder_success_text: "Votre précommande #{ref} est bien enregistrée. Nous vous préviendrons dès l'arrivée des produits.",
    preorder_whatsapp: "Confirmer sur WhatsApp",
    // Navigation
    nav_home: "Accueil",
    nav_catalogue: "Catalogue",
    nav_orders: "Commandes",
    nav_admin: "Admin",
    nav_login: "Connexion",
    nav_my_account: "Mon Compte",
    nav_logout: "Déconnexion",
    nav_favorites: "Favoris",

    // Homepage
    home_search_placeholder: "Rechercher un produit ou un code EAN...",
    home_browse_catalogue: "Parcourir le catalogue complet",
    home_new_arrivals: "Nouveautés",
    home_back_in_stock: "Retour en stock",
    home_weekly_picks: "Coups de cœur de la semaine",
    home_bestsellers: "Meilleures ventes",
    home_selection: "Sélection",
    home_view_all: "Voir tout",
    banner_discover: "Découvrir",
    home_load_error: "Impossible de charger les produits",
    home_retry: "Réessayer",

    // Catalogue
    catalogue_title: "Nos Parfums",
    catalogue_collection: "Collection",
    catalogue_search_placeholder: "Rechercher par nom, marque ou code EAN...",
    catalogue_search_btn: "Rechercher",
    catalogue_filters: "Filtres",
    catalogue_clear: "Effacer",
    catalogue_categories: "Catégories",
    catalogue_brands: "Marques",
    catalogue_all: "Toutes",
    catalogue_price: "Prix (€)",
    catalogue_in_stock_only: "En stock uniquement",
    catalogue_sort_by: "Trier par",
    catalogue_sort_newest: "Plus récents",
    catalogue_sort_oldest: "Plus anciens",
    catalogue_sort_price_asc: "Prix croissant",
    catalogue_sort_price_desc: "Prix décroissant",
    catalogue_sort_name_asc: "Nom A-Z",
    catalogue_sort_name_desc: "Nom Z-A",
    catalogue_products_count: "{count} produit{plural}",
    catalogue_no_results: "Aucun produit ne correspond à vos critères.",
    catalogue_clear_filters: "Effacer les filtres",

    // Product Card
    product_out_of_stock: "Rupture",
    product_last_pieces: "Dernières pièces",
    product_added_to_cart: "{name} ajouté au panier",
    product_login_for_favorites: "Connectez-vous pour ajouter aux favoris",
    product_from: "dès",
    product_pro: "Pro",

    // Cart
    cart_title: "Panier",
    cart_your_selection: "Votre Sélection",
    cart_empty: "Votre panier est vide",
    cart_empty_desc: "Découvrez notre collection de parfums",
    cart_view_catalogue: "Voir le catalogue",
    cart_clear: "Vider le panier",
    cart_summary: "Récapitulatif",
    cart_promo_label: "Code promo",
    cart_promo_placeholder: "Entrez votre code",
    cart_promo_apply: "Appliquer",
    cart_subtotal: "Sous-total",
    cart_discount: "Réduction",
    cart_total: "Total",
    cart_checkout: "Passer la commande",
    cart_continue_shopping: "Continuer les achats",
    cart_semi_gros_unlock: "Prix semi-gros disponibles !",
    cart_semi_gros_remaining: "Ajoutez encore {count} parfum(s) pour débloquer les prix semi-gros.",
    cart_semi_gros_active: "Prix semi-gros activés ! Vous bénéficiez des tarifs professionnels.",
    cart_gros_unlock: "Passez aux prix de gros !",
    cart_gros_remaining: "Ajoutez encore {count} parfum(s) pour débloquer les meilleurs prix.",
    cart_gros_active: "Prix de gros activés ! Vous bénéficiez des meilleurs tarifs.",

    // Checkout
    checkout_title: "Commander via WhatsApp",
    checkout_finalize: "Finalisation",
    checkout_name: "Nom complet",
    checkout_phone: "Téléphone",
    checkout_address: "Adresse de livraison",
    checkout_notes: "Notes (optionnel)",
    checkout_notes_placeholder: "Instructions spéciales...",
    checkout_order_btn: "Commander via WhatsApp",
    checkout_processing: "Traitement...",
    checkout_your_order: "Votre commande",
    checkout_info: "En cliquant sur « Commander via WhatsApp », vous serez redirigé vers WhatsApp avec un message pré-rempli contenant votre commande.",

    // Login
    login_title: "Connexion",
    login_phone: "Numéro de téléphone",
    login_identifier: "Téléphone ou email",
    login_password: "Mot de passe",
    login_submit: "Se connecter",
    login_loading: "Connexion...",
    login_no_account: "Pas encore de compte ?",
    login_register: "S'inscrire",
    login_forgot: "Mot de passe oublié ?",
    login_error: "Identifiants incorrects",

    // Register
    register_title: "Créer un compte",
    register_name: "Nom complet",
    register_phone: "Numéro de téléphone",
    register_email: "Email (optionnel)",
    register_email_hint: "Pour recevoir nos offres et promotions",
    register_password: "Mot de passe",
    register_confirm_password: "Confirmer le mot de passe",
    register_submit: "Créer mon compte",
    register_loading: "Création...",
    register_has_account: "Déjà un compte ?",
    register_login: "Se connecter",
    register_password_mismatch: "Les mots de passe ne correspondent pas",

    // Forgot Password
    forgot_title: "Mot de passe oublié",
    forgot_phone: "Numéro de téléphone",
    forgot_whatsapp_btn: "Envoyer via WhatsApp",
    forgot_sent_title: "Demande envoyée",
    forgot_sent_desc: "Votre demande de réinitialisation a été envoyée via WhatsApp. Notre équipe traitera votre demande et vous communiquera votre nouveau mot de passe.",
    forgot_sent_delay: "Délai de traitement habituel : quelques minutes pendant les heures d'ouverture.",
    forgot_back_login: "Retour à la connexion",
    forgot_whatsapp_msg: "Bonjour, je souhaite réinitialiser mon mot de passe.\n\nMon numéro : {phone}\n\nMerci de traiter ma demande.",

    // Account
    account_title: "Mon Compte",
    account_orders: "Mes commandes",
    account_order_history: "Historique des commandes",
    account_no_orders: "Aucune commande pour le moment",
    account_discover: "Découvrir nos parfums",
    account_order_prefix: "Commande",
    account_ordered: "commandé",
    account_partial: "partiel",
    account_unavailable: "indisponible",
    account_note: "Note",

    // Favorites
    favorites_title: "Mes Favoris",
    favorites_count: "{count} parfum{plural} sauvegardé{plural}",
    favorites_empty: "Aucun favori pour le moment",
    favorites_empty_desc: "Explorez le catalogue et ajoutez vos parfums préférés",
    favorites_browse: "Parcourir le catalogue",

    // Confirmation
    confirmation_title: "Merci pour votre commande !",
    confirmation_desc: "Votre commande a été envoyée via WhatsApp. Notre équipe vous contactera rapidement pour confirmer votre commande.",
    confirmation_back: "Retour à l'accueil",

    // Footer
    footer_desc: "Votre destination pour les parfums de luxe. Découvrez notre collection exclusive de fragrances raffinées, disponibles en détail, en semi-gros et en gros.",
    footer_navigation: "Navigation",
    footer_contact: "Contact",
    footer_rights: "Tous droits réservés.",
    footer_luxury: "Parfums de Luxe",
    footer_shipping: "Livraison Belgique",

    // Product Detail
    product_back_catalogue: "Retour au catalogue",
    product_not_found: "Produit non trouvé",
    product_in_stock: "En stock ({count} disponibles)",
    product_out_of_stock_full: "Rupture de stock",
    product_retail_price: "Prix détail",
    product_pro_prices: "Prix Semi-gros & Gros",
    product_register_pro: "Inscrivez-vous pour accéder aux tarifs professionnels",
    product_quantity: "Quantité",
    product_add_to_cart: "Ajouter au panier",
    product_added: "Ajouté au panier",
    product_unit: "unité",

    // Pricing tiers
    tier_detail: "Détail",
    tier_semi_wholesale: "Semi-gros",
    tier_wholesale: "Gros",
    tier_unit_price: "Prix unitaire",
    tier_from_units: "À partir de {count} unités",
    tier_price_by_qty: "Prix par quantité",
    tier_current_price: "Prix unitaire actuel",

    // Change password
    change_pwd_title: "Modifier le mot de passe",
    change_pwd_current: "Mot de passe actuel",
    change_pwd_new: "Nouveau mot de passe",
    change_pwd_confirm: "Confirmer le nouveau",
    change_pwd_save: "Modifier",
    change_pwd_success: "Mot de passe modifié avec succès",
    register_network_error: "Erreur de connexion. Vérifiez votre réseau et réessayez.",
    register_generic_error: "Une erreur est survenue. Veuillez réessayer.",

    // Register - pending
    register_received: "Inscription reçue",
    register_pending_msg: "Votre compte est en attente de vérification par l'administrateur. Vous recevrez l'accès une fois votre compte approuvé.",
    auth_google_continue: "Continuer avec Google",
    auth_or: "ou",
    google_phone_title: "Presque terminé",
    google_phone_msg: "Indiquez votre numéro WhatsApp pour finaliser votre inscription. Votre compte sera ensuite vérifié par l'administrateur.",
    register_back_login: "Retour à la connexion",
    register_email_label: "Adresse email",
    register_email_optional: "Optionnel — pour recevoir nos offres",

    // Account
    account_hello: "Bonjour, {name}",

    // Favorites - not logged in
    favorites_login_title: "Vos Favoris",
    favorites_login_desc: "Connectez-vous pour voir vos produits favoris",
    favorites_login_btn: "Se connecter",
    favorites_saved: "Produits Favoris",
    favorites_empty_tap: "Appuyez sur le cœur pour sauvegarder vos produits préférés",
    favorites_others: "+{count} autres",

    // Common / Status (canonical new flow + legacy aliases)
    status_pending: "En attente",
    status_processing: "En préparation",
    status_ready: "Terminée — en attente paiement",
    status_shipped: "Envoyée",
    status_delivered: "Livrée",
    status_cancelled: "Annulée",
    status_confirmed: "Terminée — en attente paiement",
    loading: "Chargement...",
    detail: "détail",
    min: "Min",
    max: "Max",
  },

  en: {
    home_promos: "Current promotions",
    catalogue_promo_only: "Promotions only",
    promo_until: "Until {date}",
    forgot_admin_desc_failed: "The email could not be sent: our team has been notified and will send you a temporary password on WhatsApp. You can also message us directly:",
    login_remember: "Keep me signed in for 30 days",
    register_email_required: "Required — lets you recover your account if you forget your password",
    forgot_desc: "Enter your phone number or email. If an email is linked to your account you'll receive a reset link; otherwise our team will send you a temporary password on WhatsApp.",
    forgot_identifier: "Phone or email",
    forgot_submit: "Recover my account",
    forgot_error: "Request failed, please try again.",
    forgot_email_title: "Email sent",
    forgot_email_desc: "A reset link was sent to {email}. It is valid for 1 hour.",
    forgot_email_hint: "Check your spam folder too.",
    forgot_admin_title: "Request received",
    forgot_admin_desc: "No email is linked to your account: our team has been notified and will send you a temporary password on WhatsApp. You can also message us directly:",
    forgot_none_title: "Account not found",
    forgot_none_desc: "We couldn't find an account with this identifier. Contact us on WhatsApp and we'll find it together.",
    reset_title: "New password",
    reset_desc: "Choose a new password (6 characters minimum).",
    reset_new_password: "New password",
    reset_confirm_password: "Confirm password",
    reset_submit: "Save",
    reset_mismatch: "Passwords do not match",
    reset_error: "Invalid or expired link",
    reset_invalid: "This link is invalid. Request a new one from “Forgot password”.",
    reset_done_title: "Password updated",
    reset_done_desc: "You can now sign in. Redirecting…",
    nudge_email_title: "Secure your account",
    nudge_email_desc: "Add your email address so you can recover your account yourself if you forget your password.",
    nudge_later: "Later",
    nudge_save: "Save",
    nudge_email_saved: "Email saved",
    nudge_email_error: "Invalid email address",
    nudge_temp_password: "You are using a temporary password. Choose a new one to secure your account.",
    nudge_change_now: "Change it now",
    nav_preorder: "Pre-order",
    status_preorder: "Pre-order (incoming)",
    product_preorder_badge: "Pre-order",
    product_preorder_link: "This product is arriving soon — pre-order it",
    preorder_kicker: "Upcoming arrivals",
    preorder_title: "Pre-orders",
    preorder_subtitle: "New releases and restocks expected from our suppliers. Reserve your pieces now: they ship as soon as we receive them, on the date shown.",
    preorder_empty: "No pre-order arrivals right now. Check back soon!",
    preorder_expected: "Expected on",
    preorder_available: "{count} piece(s) available to pre-order",
    preorder_sold_out: "Sold out",
    preorder_items: "{count} item(s) to pre-order",
    preorder_continue: "Pre-order",
    preorder_login_required: "Please log in to confirm your pre-order.",
    preorder_back: "Back",
    preorder_submit: "Send my pre-order",
    preorder_summary: "Your pre-order",
    preorder_delivery_note: "Delivery expected from {date}, as soon as goods arrive. No payment now.",
    preorder_error: "The pre-order could not be saved.",
    preorder_success_title: "Pre-order saved",
    preorder_success_text: "Your pre-order #{ref} is saved. We will notify you when products arrive.",
    preorder_whatsapp: "Confirm on WhatsApp",
    nav_home: "Home",
    nav_catalogue: "Catalogue",
    nav_orders: "Orders",
    nav_admin: "Admin",
    nav_login: "Login",
    nav_my_account: "My Account",
    nav_logout: "Log out",
    nav_favorites: "Favorites",
    home_search_placeholder: "Search a product or EAN code...",
    home_browse_catalogue: "Browse the full catalogue",
    home_new_arrivals: "New Arrivals",
    home_back_in_stock: "Back in Stock",
    home_weekly_picks: "Weekly Picks",
    home_bestsellers: "Bestsellers",
    home_selection: "Selection",
    home_view_all: "View all",
    banner_discover: "Discover",
    home_load_error: "Unable to load products",
    home_retry: "Retry",
    catalogue_title: "Our Perfumes",
    catalogue_collection: "Collection",
    catalogue_search_placeholder: "Search by name, brand or EAN code...",
    catalogue_search_btn: "Search",
    catalogue_filters: "Filters",
    catalogue_clear: "Clear",
    catalogue_categories: "Categories",
    catalogue_brands: "Brands",
    catalogue_all: "All",
    catalogue_price: "Price (€)",
    catalogue_in_stock_only: "In stock only",
    catalogue_sort_by: "Sort by",
    catalogue_sort_newest: "Newest",
    catalogue_sort_oldest: "Oldest",
    catalogue_sort_price_asc: "Price: low to high",
    catalogue_sort_price_desc: "Price: high to low",
    catalogue_sort_name_asc: "Name A-Z",
    catalogue_sort_name_desc: "Name Z-A",
    catalogue_products_count: "{count} product{plural}",
    catalogue_no_results: "No products match your criteria.",
    catalogue_clear_filters: "Clear filters",
    product_out_of_stock: "Out of stock",
    product_last_pieces: "Last pieces",
    product_added_to_cart: "{name} added to cart",
    product_login_for_favorites: "Log in to add to favorites",
    product_from: "from",
    product_pro: "Pro",
    cart_title: "Cart",
    cart_your_selection: "Your Selection",
    cart_empty: "Your cart is empty",
    cart_empty_desc: "Discover our perfume collection",
    cart_view_catalogue: "View catalogue",
    cart_clear: "Clear cart",
    cart_summary: "Summary",
    cart_promo_label: "Promo code",
    cart_promo_placeholder: "Enter your code",
    cart_promo_apply: "Apply",
    cart_subtotal: "Subtotal",
    cart_discount: "Discount",
    cart_total: "Total",
    cart_checkout: "Place order",
    cart_continue_shopping: "Continue shopping",
    cart_semi_gros_unlock: "Semi-wholesale prices available!",
    cart_semi_gros_remaining: "Add {count} more perfume(s) to unlock semi-wholesale prices.",
    cart_semi_gros_active: "Semi-wholesale prices active! You benefit from professional rates.",
    cart_gros_unlock: "Upgrade to wholesale prices!",
    cart_gros_remaining: "Add {count} more perfume(s) to unlock the best prices.",
    cart_gros_active: "Wholesale prices active! You benefit from the best rates.",
    checkout_title: "Order via WhatsApp",
    checkout_finalize: "Checkout",
    checkout_name: "Full name",
    checkout_phone: "Phone",
    checkout_address: "Delivery address",
    checkout_notes: "Notes (optional)",
    checkout_notes_placeholder: "Special instructions...",
    checkout_order_btn: "Order via WhatsApp",
    checkout_processing: "Processing...",
    checkout_your_order: "Your order",
    checkout_info: "By clicking \"Order via WhatsApp\", you will be redirected to WhatsApp with a pre-filled message containing your order.",
    login_title: "Login",
    login_phone: "Phone number",
    login_identifier: "Phone or email",
    login_password: "Password",
    login_submit: "Log in",
    login_loading: "Logging in...",
    login_no_account: "No account yet?",
    login_register: "Sign up",
    login_forgot: "Forgot password?",
    login_error: "Invalid credentials",
    register_title: "Create an account",
    register_name: "Full name",
    register_phone: "Phone number",
    register_email: "Email (optional)",
    register_email_hint: "To receive our offers and promotions",
    register_password: "Password",
    register_confirm_password: "Confirm password",
    register_submit: "Create my account",
    register_loading: "Creating...",
    register_has_account: "Already have an account?",
    register_login: "Log in",
    register_password_mismatch: "Passwords do not match",
    forgot_title: "Forgot password",
    forgot_phone: "Phone number",
    forgot_whatsapp_btn: "Send via WhatsApp",
    forgot_sent_title: "Request sent",
    forgot_sent_desc: "Your password reset request has been sent via WhatsApp. Our team will process your request and provide you with a new password.",
    forgot_sent_delay: "Usual processing time: a few minutes during business hours.",
    forgot_back_login: "Back to login",
    forgot_whatsapp_msg: "Hello, I would like to reset my password.\n\nMy number: {phone}\n\nThank you.",
    account_title: "My Account",
    account_orders: "My orders",
    account_order_history: "Order history",
    account_no_orders: "No orders yet",
    account_discover: "Discover our perfumes",
    account_order_prefix: "Order",
    account_ordered: "ordered",
    account_partial: "partial",
    account_unavailable: "unavailable",
    account_note: "Note",
    favorites_title: "My Favorites",
    favorites_count: "{count} perfume{plural} saved",
    favorites_empty: "No favorites yet",
    favorites_empty_desc: "Browse the catalogue and add your favorite perfumes",
    favorites_browse: "Browse catalogue",
    confirmation_title: "Thank you for your order!",
    confirmation_desc: "Your order has been sent via WhatsApp. Our team will contact you shortly to confirm your order.",
    confirmation_back: "Back to home",
    footer_desc: "Your destination for luxury perfumes. Discover our exclusive collection of refined fragrances, available retail, semi-wholesale and wholesale.",
    footer_navigation: "Navigation",
    footer_contact: "Contact",
    footer_rights: "All rights reserved.",
    footer_luxury: "Luxury Perfumes",
    footer_shipping: "Delivery Belgium",
    status_pending: "Pending",
    status_confirmed: "Ready — awaiting payment",
    status_ready: "Ready — awaiting payment",
    status_processing: "Processing",
    status_shipped: "Sent",
    status_delivered: "Delivered",
    status_cancelled: "Cancelled",
    loading: "Loading...",
    detail: "retail",
    product_back_catalogue: "Back to catalogue",
    product_not_found: "Product not found",
    product_in_stock: "In stock ({count} available)",
    product_out_of_stock_full: "Out of stock",
    product_retail_price: "Retail price",
    product_pro_prices: "Semi-wholesale & Wholesale prices",
    product_register_pro: "Sign up to access professional prices",
    product_quantity: "Quantity",
    product_add_to_cart: "Add to cart",
    product_added: "Added to cart",
    product_unit: "unit",
    tier_detail: "Retail",
    tier_semi_wholesale: "Semi-wholesale",
    tier_wholesale: "Wholesale",
    tier_unit_price: "Unit price",
    tier_from_units: "From {count} units",
    tier_price_by_qty: "Price by quantity",
    tier_current_price: "Current unit price",
    change_pwd_title: "Change password",
    change_pwd_current: "Current password",
    change_pwd_new: "New password",
    change_pwd_confirm: "Confirm new password",
    change_pwd_save: "Update",
    change_pwd_success: "Password changed successfully",
    register_network_error: "Connection error. Check your network and try again.",
    register_generic_error: "An error occurred. Please try again.",
    register_received: "Registration received",
    register_pending_msg: "Your account is pending approval by the administrator. You will receive access once approved.",
    auth_google_continue: "Continue with Google",
    auth_or: "or",
    google_phone_title: "Almost done",
    google_phone_msg: "Enter your WhatsApp number to finish signing up. Your account will then be verified by the administrator.",
    register_back_login: "Back to login",
    register_email_label: "Email address",
    register_email_optional: "Optional — to receive our offers",
    account_hello: "Hello, {name}",
    favorites_login_title: "Your Favorites",
    favorites_login_desc: "Log in to see your favorite products",
    favorites_login_btn: "Log in",
    favorites_saved: "Favorite Products",
    favorites_empty_tap: "Tap the heart to save your favorite products",
    favorites_others: "+{count} more",
    min: "Min",
    max: "Max",
  },

  nl: {
    home_promos: "Huidige promoties",
    catalogue_promo_only: "Alleen promoties",
    promo_until: "Tot {date}",
    forgot_admin_desc_failed: "De e-mail kon niet worden verzonden: ons team is verwittigd en stuurt u een tijdelijk wachtwoord via WhatsApp. U kunt ons ook rechtstreeks schrijven:",
    login_remember: "30 dagen aangemeld blijven",
    register_email_required: "Verplicht — om uw account te herstellen bij vergeten wachtwoord",
    forgot_desc: "Voer uw telefoonnummer of e-mail in. Als er een e-mail aan uw account is gekoppeld, ontvangt u een herstellink; anders stuurt ons team u een tijdelijk wachtwoord via WhatsApp.",
    forgot_identifier: "Telefoon of e-mail",
    forgot_submit: "Mijn account herstellen",
    forgot_error: "Aanvraag mislukt, probeer opnieuw.",
    forgot_email_title: "E-mail verzonden",
    forgot_email_desc: "Een herstellink is verzonden naar {email}. Geldig gedurende 1 uur.",
    forgot_email_hint: "Controleer ook uw spammap.",
    forgot_admin_title: "Aanvraag ontvangen",
    forgot_admin_desc: "Geen e-mail gekoppeld aan uw account: ons team is verwittigd en stuurt u een tijdelijk wachtwoord via WhatsApp. U kunt ons ook rechtstreeks schrijven:",
    forgot_none_title: "Account niet gevonden",
    forgot_none_desc: "Geen account gevonden met deze gegevens. Contacteer ons via WhatsApp.",
    reset_title: "Nieuw wachtwoord",
    reset_desc: "Kies een nieuw wachtwoord (minimaal 6 tekens).",
    reset_new_password: "Nieuw wachtwoord",
    reset_confirm_password: "Bevestig wachtwoord",
    reset_submit: "Opslaan",
    reset_mismatch: "Wachtwoorden komen niet overeen",
    reset_error: "Ongeldige of verlopen link",
    reset_invalid: "Deze link is ongeldig. Vraag een nieuwe aan via « Wachtwoord vergeten ».",
    reset_done_title: "Wachtwoord gewijzigd",
    reset_done_desc: "U kunt nu inloggen. Doorsturen…",
    nudge_email_title: "Beveilig uw account",
    nudge_email_desc: "Voeg uw e-mailadres toe om uw account zelf te kunnen herstellen.",
    nudge_later: "Later",
    nudge_save: "Opslaan",
    nudge_email_saved: "E-mail opgeslagen",
    nudge_email_error: "Ongeldig e-mailadres",
    nudge_temp_password: "U gebruikt een tijdelijk wachtwoord. Kies een nieuw wachtwoord.",
    nudge_change_now: "Nu wijzigen",
    nav_preorder: "Voorbestelling",
    status_preorder: "Voorbestelling (onderweg)",
    product_preorder_badge: "Voorbestelling",
    product_preorder_link: "Dit product komt binnenkort — bestel het voor",
    preorder_kicker: "Binnenkort verwacht",
    preorder_title: "Voorbestellingen",
    preorder_subtitle: "Nieuwe producten en herbevoorradingen verwacht van onze leveranciers. Reserveer nu: levering zodra ontvangen, op de aangegeven datum.",
    preorder_empty: "Momenteel geen voorbestellingen. Kom snel terug!",
    preorder_expected: "Verwacht op",
    preorder_available: "{count} stuk(s) beschikbaar",
    preorder_sold_out: "Uitverkocht",
    preorder_items: "{count} artikel(en)",
    preorder_continue: "Voorbestellen",
    preorder_login_required: "Log in om uw voorbestelling te bevestigen.",
    preorder_back: "Terug",
    preorder_submit: "Voorbestelling verzenden",
    preorder_summary: "Uw voorbestelling",
    preorder_delivery_note: "Levering verwacht vanaf {date}, zodra de goederen ontvangen zijn. Geen betaling nu.",
    preorder_error: "De voorbestelling kon niet worden opgeslagen.",
    preorder_success_title: "Voorbestelling opgeslagen",
    preorder_success_text: "Uw voorbestelling #{ref} is opgeslagen. We verwittigen u bij aankomst.",
    preorder_whatsapp: "Bevestigen via WhatsApp",
    nav_home: "Home",
    nav_catalogue: "Catalogus",
    nav_orders: "Bestellingen",
    nav_admin: "Admin",
    nav_login: "Inloggen",
    nav_my_account: "Mijn Account",
    nav_logout: "Uitloggen",
    nav_favorites: "Favorieten",
    home_search_placeholder: "Zoek een product of EAN-code...",
    home_browse_catalogue: "Bekijk de volledige catalogus",
    home_new_arrivals: "Nieuw",
    home_back_in_stock: "Weer op voorraad",
    home_weekly_picks: "Favorieten van de week",
    home_bestsellers: "Bestsellers",
    home_selection: "Selectie",
    home_view_all: "Alles bekijken",
    banner_discover: "Ontdekken",
    home_load_error: "Producten konden niet geladen worden",
    home_retry: "Opnieuw proberen",
    catalogue_title: "Onze Parfums",
    catalogue_collection: "Collectie",
    catalogue_search_placeholder: "Zoek op naam, merk of EAN-code...",
    catalogue_search_btn: "Zoeken",
    catalogue_filters: "Filters",
    catalogue_clear: "Wissen",
    catalogue_categories: "Categorieën",
    catalogue_brands: "Merken",
    catalogue_all: "Alle",
    catalogue_price: "Prijs (€)",
    catalogue_in_stock_only: "Alleen op voorraad",
    catalogue_sort_by: "Sorteren op",
    catalogue_sort_newest: "Nieuwste",
    catalogue_sort_oldest: "Oudste",
    catalogue_sort_price_asc: "Prijs oplopend",
    catalogue_sort_price_desc: "Prijs aflopend",
    catalogue_sort_name_asc: "Naam A-Z",
    catalogue_sort_name_desc: "Naam Z-A",
    catalogue_products_count: "{count} product{plural}",
    catalogue_no_results: "Geen producten gevonden.",
    catalogue_clear_filters: "Filters wissen",
    product_out_of_stock: "Uitverkocht",
    product_last_pieces: "Laatste stuks",
    product_added_to_cart: "{name} toegevoegd aan winkelwagen",
    product_login_for_favorites: "Log in om favorieten toe te voegen",
    product_from: "vanaf",
    product_pro: "Pro",
    cart_title: "Winkelwagen",
    cart_your_selection: "Uw Selectie",
    cart_empty: "Uw winkelwagen is leeg",
    cart_empty_desc: "Ontdek onze parfumcollectie",
    cart_view_catalogue: "Bekijk catalogus",
    cart_clear: "Winkelwagen legen",
    cart_summary: "Overzicht",
    cart_promo_label: "Promotiecode",
    cart_promo_placeholder: "Voer uw code in",
    cart_promo_apply: "Toepassen",
    cart_subtotal: "Subtotaal",
    cart_discount: "Korting",
    cart_total: "Totaal",
    cart_checkout: "Bestelling plaatsen",
    cart_continue_shopping: "Verder winkelen",
    cart_semi_gros_unlock: "Halfgroothandelsprijzen beschikbaar!",
    cart_semi_gros_remaining: "Voeg nog {count} parfum(s) toe om halfgroothandelsprijzen te ontgrendelen.",
    cart_semi_gros_active: "Halfgroothandelsprijzen actief! U profiteert van professionele tarieven.",
    cart_gros_unlock: "Schakel over naar groothandelsprijzen!",
    cart_gros_remaining: "Voeg nog {count} parfum(s) toe voor de beste prijzen.",
    cart_gros_active: "Groothandelsprijzen actief! U profiteert van de beste tarieven.",
    checkout_title: "Bestellen via WhatsApp",
    checkout_finalize: "Afrekenen",
    checkout_name: "Volledige naam",
    checkout_phone: "Telefoon",
    checkout_address: "Leveradres",
    checkout_notes: "Opmerkingen (optioneel)",
    checkout_notes_placeholder: "Speciale instructies...",
    checkout_order_btn: "Bestellen via WhatsApp",
    checkout_processing: "Verwerken...",
    checkout_your_order: "Uw bestelling",
    checkout_info: "Door op \"Bestellen via WhatsApp\" te klikken, wordt u doorgestuurd naar WhatsApp met een vooraf ingevuld bericht met uw bestelling.",
    login_title: "Inloggen",
    login_phone: "Telefoonnummer",
    login_identifier: "Telefoon of e-mail",
    login_password: "Wachtwoord",
    login_submit: "Inloggen",
    login_loading: "Inloggen...",
    login_no_account: "Nog geen account?",
    login_register: "Registreren",
    login_forgot: "Wachtwoord vergeten?",
    login_error: "Ongeldige inloggegevens",
    register_title: "Account aanmaken",
    register_name: "Volledige naam",
    register_phone: "Telefoonnummer",
    register_email: "E-mail (optioneel)",
    register_email_hint: "Om onze aanbiedingen te ontvangen",
    register_password: "Wachtwoord",
    register_confirm_password: "Wachtwoord bevestigen",
    register_submit: "Account aanmaken",
    register_loading: "Aanmaken...",
    register_has_account: "Heeft u al een account?",
    register_login: "Inloggen",
    register_password_mismatch: "Wachtwoorden komen niet overeen",
    forgot_title: "Wachtwoord vergeten",
    forgot_phone: "Telefoonnummer",
    forgot_whatsapp_btn: "Versturen via WhatsApp",
    forgot_sent_title: "Aanvraag verzonden",
    forgot_sent_desc: "Uw verzoek tot wachtwoordreset is verzonden via WhatsApp. Ons team zal uw aanvraag verwerken.",
    forgot_sent_delay: "Gebruikelijke verwerkingstijd: enkele minuten tijdens openingstijden.",
    forgot_back_login: "Terug naar inloggen",
    forgot_whatsapp_msg: "Hallo, ik wil mijn wachtwoord resetten.\n\nMijn nummer: {phone}\n\nBedankt.",
    account_title: "Mijn Account",
    account_orders: "Mijn bestellingen",
    account_order_history: "Bestelgeschiedenis",
    account_no_orders: "Nog geen bestellingen",
    account_discover: "Ontdek onze parfums",
    account_order_prefix: "Bestelling",
    account_ordered: "besteld",
    account_partial: "gedeeltelijk",
    account_unavailable: "niet beschikbaar",
    account_note: "Opmerking",
    favorites_title: "Mijn Favorieten",
    favorites_count: "{count} parfum{plural} opgeslagen",
    favorites_empty: "Nog geen favorieten",
    favorites_empty_desc: "Bekijk de catalogus en voeg uw favoriete parfums toe",
    favorites_browse: "Bekijk catalogus",
    confirmation_title: "Bedankt voor uw bestelling!",
    confirmation_desc: "Uw bestelling is verzonden via WhatsApp. Ons team neemt snel contact met u op.",
    confirmation_back: "Terug naar home",
    footer_desc: "Uw bestemming voor luxe parfums. Ontdek onze exclusieve collectie verfijnde geuren, beschikbaar in detail, halfgroot en groothandel.",
    footer_navigation: "Navigatie",
    footer_contact: "Contact",
    footer_rights: "Alle rechten voorbehouden.",
    footer_luxury: "Luxe Parfums",
    footer_shipping: "Levering België",
    status_pending: "In behandeling",
    status_confirmed: "Klaar — wachten op betaling",
    status_ready: "Klaar — wachten op betaling",
    status_processing: "In voorbereiding",
    status_shipped: "Verzonden",
    status_delivered: "Afgeleverd",
    status_cancelled: "Geannuleerd",
    loading: "Laden...",
    detail: "detail",
    product_back_catalogue: "Terug naar catalogus",
    product_not_found: "Product niet gevonden",
    product_in_stock: "Op voorraad ({count} beschikbaar)",
    product_out_of_stock_full: "Uitverkocht",
    product_retail_price: "Detailprijs",
    product_pro_prices: "Halfgroot- & Groothandelsprijzen",
    product_register_pro: "Registreer om professionele prijzen te zien",
    product_quantity: "Aantal",
    product_add_to_cart: "In winkelwagen",
    product_added: "Toegevoegd",
    product_unit: "stuk",
    tier_detail: "Detail",
    tier_semi_wholesale: "Halfgroot",
    tier_wholesale: "Groothandel",
    tier_unit_price: "Stukprijs",
    tier_from_units: "Vanaf {count} stuks",
    tier_price_by_qty: "Prijs per hoeveelheid",
    tier_current_price: "Huidige stukprijs",
    change_pwd_title: "Wachtwoord wijzigen",
    change_pwd_current: "Huidig wachtwoord",
    change_pwd_new: "Nieuw wachtwoord",
    change_pwd_confirm: "Bevestig nieuw wachtwoord",
    change_pwd_save: "Wijzigen",
    change_pwd_success: "Wachtwoord succesvol gewijzigd",
    register_network_error: "Verbindingsfout. Controleer uw netwerk en probeer opnieuw.",
    register_generic_error: "Er is een fout opgetreden. Probeer het opnieuw.",
    register_received: "Registratie ontvangen",
    register_pending_msg: "Uw account wacht op goedkeuring door de beheerder. U krijgt toegang zodra het is goedgekeurd.",
    auth_google_continue: "Doorgaan met Google",
    auth_or: "of",
    google_phone_title: "Bijna klaar",
    google_phone_msg: "Geef uw WhatsApp-nummer op om uw registratie af te ronden. Uw account wordt daarna door de beheerder gecontroleerd.",
    register_back_login: "Terug naar inloggen",
    register_email_label: "E-mailadres",
    register_email_optional: "Optioneel — om onze aanbiedingen te ontvangen",
    account_hello: "Hallo, {name}",
    favorites_login_title: "Uw Favorieten",
    favorites_login_desc: "Log in om uw favoriete producten te zien",
    favorites_login_btn: "Inloggen",
    favorites_saved: "Favoriete Producten",
    favorites_empty_tap: "Tik op het hartje om uw favoriete producten op te slaan",
    favorites_others: "+{count} meer",
    min: "Min",
    max: "Max",
  },

  "pt-BR": {
    home_promos: "Promoções do momento",
    catalogue_promo_only: "Somente promoções",
    promo_until: "Até {date}",
    forgot_admin_desc_failed: "O e-mail não pôde ser enviado: nossa equipe foi avisada e enviará uma senha temporária pelo WhatsApp. Você também pode nos escrever:",
    login_remember: "Manter conectado por 30 dias",
    register_email_required: "Obrigatório — permite recuperar sua conta se esquecer a senha",
    forgot_desc: "Informe seu telefone ou e-mail. Se houver um e-mail vinculado, você receberá um link de redefinição; caso contrário nossa equipe enviará uma senha temporária pelo WhatsApp.",
    forgot_identifier: "Telefone ou e-mail",
    forgot_submit: "Recuperar minha conta",
    forgot_error: "Falha na solicitação, tente novamente.",
    forgot_email_title: "E-mail enviado",
    forgot_email_desc: "Um link de redefinição foi enviado para {email}. Válido por 1 hora.",
    forgot_email_hint: "Verifique também a pasta de spam.",
    forgot_admin_title: "Solicitação recebida",
    forgot_admin_desc: "Nenhum e-mail vinculado à sua conta: nossa equipe foi avisada e enviará uma senha temporária pelo WhatsApp. Você também pode nos escrever:",
    forgot_none_title: "Conta não encontrada",
    forgot_none_desc: "Não encontramos uma conta com esse identificador. Fale conosco no WhatsApp.",
    reset_title: "Nova senha",
    reset_desc: "Escolha uma nova senha (mínimo 6 caracteres).",
    reset_new_password: "Nova senha",
    reset_confirm_password: "Confirmar senha",
    reset_submit: "Salvar",
    reset_mismatch: "As senhas não coincidem",
    reset_error: "Link inválido ou expirado",
    reset_invalid: "Link inválido. Faça uma nova solicitação em “Esqueci a senha”.",
    reset_done_title: "Senha alterada",
    reset_done_desc: "Agora você pode entrar. Redirecionando…",
    nudge_email_title: "Proteja sua conta",
    nudge_email_desc: "Adicione seu e-mail para poder recuperar sua conta sozinho.",
    nudge_later: "Depois",
    nudge_save: "Salvar",
    nudge_email_saved: "E-mail salvo",
    nudge_email_error: "E-mail inválido",
    nudge_temp_password: "Você está usando uma senha temporária. Escolha uma nova.",
    nudge_change_now: "Alterar agora",
    nav_preorder: "Pré-venda",
    status_preorder: "Pré-venda (a chegar)",
    product_preorder_badge: "Pré-venda",
    product_preorder_link: "Este produto chega em breve — reserve-o",
    preorder_kicker: "Próximas chegadas",
    preorder_title: "Pré-vendas",
    preorder_subtitle: "Novidades e reposições esperadas dos nossos fornecedores. Reserve agora: entrega assim que recebermos, na data indicada.",
    preorder_empty: "Nenhuma pré-venda no momento. Volte em breve!",
    preorder_expected: "Chegada prevista em",
    preorder_available: "{count} unidade(s) disponíveis",
    preorder_sold_out: "Esgotado",
    preorder_items: "{count} item(ns)",
    preorder_continue: "Reservar",
    preorder_login_required: "Faça login para confirmar sua pré-venda.",
    preorder_back: "Voltar",
    preorder_submit: "Enviar minha pré-venda",
    preorder_summary: "Sua pré-venda",
    preorder_delivery_note: "Entrega prevista a partir de {date}, ao receber a mercadoria. Sem pagamento agora.",
    preorder_error: "Não foi possível salvar a pré-venda.",
    preorder_success_title: "Pré-venda registrada",
    preorder_success_text: "Sua pré-venda #{ref} foi registrada. Avisaremos quando os produtos chegarem.",
    preorder_whatsapp: "Confirmar no WhatsApp",
    nav_home: "Início",
    nav_catalogue: "Catálogo",
    nav_orders: "Pedidos",
    nav_admin: "Admin",
    nav_login: "Entrar",
    nav_my_account: "Minha Conta",
    nav_logout: "Sair",
    nav_favorites: "Favoritos",
    home_search_placeholder: "Buscar um produto ou código EAN...",
    home_browse_catalogue: "Ver catálogo completo",
    home_new_arrivals: "Novidades",
    home_back_in_stock: "De volta ao estoque",
    home_weekly_picks: "Queridinhos da semana",
    home_bestsellers: "Mais vendidos",
    home_selection: "Seleção",
    home_view_all: "Ver tudo",
    home_load_error: "Não foi possível carregar os produtos",
    home_retry: "Tentar novamente",
    catalogue_title: "Nossos Perfumes",
    catalogue_collection: "Coleção",
    catalogue_search_placeholder: "Buscar por nome, marca ou código EAN...",
    catalogue_search_btn: "Buscar",
    catalogue_filters: "Filtros",
    catalogue_clear: "Limpar",
    catalogue_categories: "Categorias",
    catalogue_brands: "Marcas",
    catalogue_all: "Todas",
    catalogue_price: "Preço (€)",
    catalogue_in_stock_only: "Somente em estoque",
    catalogue_sort_by: "Ordenar por",
    catalogue_sort_newest: "Mais recentes",
    catalogue_sort_oldest: "Mais antigos",
    catalogue_sort_price_asc: "Preço crescente",
    catalogue_sort_price_desc: "Preço decrescente",
    catalogue_sort_name_asc: "Nome A-Z",
    catalogue_sort_name_desc: "Nome Z-A",
    catalogue_products_count: "{count} produto{plural}",
    catalogue_no_results: "Nenhum produto corresponde aos seus critérios.",
    catalogue_clear_filters: "Limpar filtros",
    product_out_of_stock: "Esgotado",
    product_last_pieces: "Últimas unidades",
    product_added_to_cart: "{name} adicionado ao carrinho",
    product_login_for_favorites: "Faça login para adicionar aos favoritos",
    product_from: "a partir de",
    product_pro: "Pro",
    cart_title: "Carrinho",
    cart_your_selection: "Sua Seleção",
    cart_empty: "Seu carrinho está vazio",
    cart_empty_desc: "Descubra nossa coleção de perfumes",
    cart_view_catalogue: "Ver catálogo",
    cart_clear: "Esvaziar carrinho",
    cart_summary: "Resumo",
    cart_promo_label: "Código promocional",
    cart_promo_placeholder: "Digite seu código",
    cart_promo_apply: "Aplicar",
    cart_subtotal: "Subtotal",
    cart_discount: "Desconto",
    cart_total: "Total",
    cart_checkout: "Fazer pedido",
    cart_continue_shopping: "Continuar comprando",
    cart_semi_gros_unlock: "Preços semi-atacado disponíveis!",
    cart_semi_gros_remaining: "Adicione mais {count} perfume(s) para desbloquear preços semi-atacado.",
    cart_semi_gros_active: "Preços semi-atacado ativos! Você se beneficia das taxas profissionais.",
    cart_gros_unlock: "Passe para preços de atacado!",
    cart_gros_remaining: "Adicione mais {count} perfume(s) para os melhores preços.",
    cart_gros_active: "Preços de atacado ativos! Você se beneficia das melhores taxas.",
    checkout_title: "Pedir via WhatsApp",
    checkout_finalize: "Finalização",
    checkout_name: "Nome completo",
    checkout_phone: "Telefone",
    checkout_address: "Endereço de entrega",
    checkout_notes: "Notas (opcional)",
    checkout_notes_placeholder: "Instruções especiais...",
    checkout_order_btn: "Pedir via WhatsApp",
    checkout_processing: "Processando...",
    checkout_your_order: "Seu pedido",
    checkout_info: "Ao clicar em \"Pedir via WhatsApp\", você será redirecionado ao WhatsApp com uma mensagem pré-preenchida com seu pedido.",
    login_title: "Entrar",
    login_phone: "Número de telefone",
    login_identifier: "Telefone ou email",
    login_password: "Senha",
    login_submit: "Entrar",
    login_loading: "Entrando...",
    login_no_account: "Ainda não tem conta?",
    login_register: "Cadastrar-se",
    login_forgot: "Esqueceu a senha?",
    login_error: "Credenciais inválidas",
    register_title: "Criar uma conta",
    register_name: "Nome completo",
    register_phone: "Número de telefone",
    register_email: "Email (opcional)",
    register_email_hint: "Para receber nossas ofertas e promoções",
    register_password: "Senha",
    register_confirm_password: "Confirmar senha",
    register_submit: "Criar minha conta",
    register_loading: "Criando...",
    register_has_account: "Já tem uma conta?",
    register_login: "Entrar",
    register_password_mismatch: "As senhas não coincidem",
    forgot_title: "Esqueceu a senha",
    forgot_phone: "Número de telefone",
    forgot_whatsapp_btn: "Enviar via WhatsApp",
    forgot_sent_title: "Solicitação enviada",
    forgot_sent_desc: "Sua solicitação de redefinição de senha foi enviada via WhatsApp. Nossa equipe processará sua solicitação.",
    forgot_sent_delay: "Tempo de processamento usual: alguns minutos durante o horário comercial.",
    forgot_back_login: "Voltar ao login",
    forgot_whatsapp_msg: "Olá, gostaria de redefinir minha senha.\n\nMeu número: {phone}\n\nObrigado.",
    account_title: "Minha Conta",
    account_orders: "Meus pedidos",
    account_order_history: "Histórico de pedidos",
    account_no_orders: "Nenhum pedido ainda",
    account_discover: "Descubra nossos perfumes",
    account_order_prefix: "Pedido",
    account_ordered: "pedido",
    account_partial: "parcial",
    account_unavailable: "indisponível",
    account_note: "Nota",
    favorites_title: "Meus Favoritos",
    favorites_count: "{count} perfume{plural} salvo{plural}",
    favorites_empty: "Nenhum favorito ainda",
    favorites_empty_desc: "Explore o catálogo e adicione seus perfumes favoritos",
    favorites_browse: "Ver catálogo",
    confirmation_title: "Obrigado pelo seu pedido!",
    confirmation_desc: "Seu pedido foi enviado via WhatsApp. Nossa equipe entrará em contato em breve.",
    confirmation_back: "Voltar ao início",
    footer_desc: "Seu destino para perfumes de luxo. Descubra nossa coleção exclusiva de fragrâncias refinadas, disponíveis no varejo, semi-atacado e atacado.",
    footer_navigation: "Navegação",
    footer_contact: "Contato",
    footer_rights: "Todos os direitos reservados.",
    footer_luxury: "Perfumes de Luxo",
    footer_shipping: "Entrega Bélgica",
    status_pending: "Pendente",
    status_confirmed: "Pronto — aguardando pagamento",
    status_ready: "Pronto — aguardando pagamento",
    status_processing: "Em preparação",
    status_shipped: "Enviado",
    status_delivered: "Entregue",
    status_cancelled: "Cancelado",
    loading: "Carregando...",
    detail: "varejo",
    product_back_catalogue: "Voltar ao catálogo",
    product_not_found: "Produto não encontrado",
    product_in_stock: "Em estoque ({count} disponíveis)",
    product_out_of_stock_full: "Fora de estoque",
    product_retail_price: "Preço varejo",
    product_pro_prices: "Preços semi-atacado e atacado",
    product_register_pro: "Cadastre-se para acessar preços profissionais",
    product_quantity: "Quantidade",
    product_add_to_cart: "Adicionar ao carrinho",
    product_added: "Adicionado",
    product_unit: "unidade",
    tier_detail: "Varejo",
    tier_semi_wholesale: "Semi-atacado",
    tier_wholesale: "Atacado",
    tier_unit_price: "Preço unitário",
    tier_from_units: "A partir de {count} unidades",
    tier_price_by_qty: "Preço por quantidade",
    tier_current_price: "Preço unitário atual",
    change_pwd_title: "Alterar senha",
    change_pwd_current: "Senha atual",
    change_pwd_new: "Nova senha",
    change_pwd_confirm: "Confirmar nova senha",
    change_pwd_save: "Alterar",
    change_pwd_success: "Senha alterada com sucesso",
    register_network_error: "Erro de conexão. Verifique sua rede e tente novamente.",
    register_generic_error: "Ocorreu um erro. Tente novamente.",
    register_received: "Cadastro recebido",
    register_pending_msg: "Sua conta está aguardando aprovação do administrador. Você receberá acesso assim que aprovada.",
    auth_google_continue: "Continuar com o Google",
    auth_or: "ou",
    google_phone_title: "Quase pronto",
    google_phone_msg: "Informe seu número de WhatsApp para concluir o cadastro. Sua conta será então verificada pelo administrador.",
    register_back_login: "Voltar ao login",
    register_email_label: "Endereço de email",
    register_email_optional: "Opcional — para receber nossas ofertas",
    account_hello: "Olá, {name}",
    favorites_login_title: "Seus Favoritos",
    favorites_login_desc: "Faça login para ver seus produtos favoritos",
    favorites_login_btn: "Entrar",
    favorites_saved: "Produtos Favoritos",
    favorites_empty_tap: "Toque no coração para salvar seus produtos favoritos",
    favorites_others: "+{count} mais",
    min: "Mín",
    max: "Máx",
  },

  es: {
    home_promos: "Promociones del momento",
    catalogue_promo_only: "Solo promociones",
    promo_until: "Hasta el {date}",
    forgot_admin_desc_failed: "No se pudo enviar el e-mail: nuestro equipo ha sido avisado y te enviará una contraseña temporal por WhatsApp. También puedes escribirnos:",
    login_remember: "Mantener la sesión 30 días",
    register_email_required: "Obligatorio — permite recuperar tu cuenta si olvidas la contraseña",
    forgot_desc: "Introduce tu teléfono o e-mail. Si hay un e-mail vinculado recibirás un enlace; si no, nuestro equipo te enviará una contraseña temporal por WhatsApp.",
    forgot_identifier: "Teléfono o e-mail",
    forgot_submit: "Recuperar mi cuenta",
    forgot_error: "No se pudo procesar, inténtalo de nuevo.",
    forgot_email_title: "E-mail enviado",
    forgot_email_desc: "Se envió un enlace a {email}. Válido 1 hora.",
    forgot_email_hint: "Revisa también el correo no deseado.",
    forgot_admin_title: "Solicitud recibida",
    forgot_admin_desc: "Tu cuenta no tiene e-mail: nuestro equipo ha sido avisado y te enviará una contraseña temporal por WhatsApp. También puedes escribirnos:",
    forgot_none_title: "Cuenta no encontrada",
    forgot_none_desc: "No encontramos ninguna cuenta con ese identificador. Contáctanos por WhatsApp.",
    reset_title: "Nueva contraseña",
    reset_desc: "Elige una nueva contraseña (mínimo 6 caracteres).",
    reset_new_password: "Nueva contraseña",
    reset_confirm_password: "Confirmar contraseña",
    reset_submit: "Guardar",
    reset_mismatch: "Las contraseñas no coinciden",
    reset_error: "Enlace inválido o caducado",
    reset_invalid: "Enlace inválido. Solicita uno nuevo desde «Contraseña olvidada».",
    reset_done_title: "Contraseña actualizada",
    reset_done_desc: "Ya puedes iniciar sesión. Redirigiendo…",
    nudge_email_title: "Protege tu cuenta",
    nudge_email_desc: "Añade tu e-mail para poder recuperar tu cuenta tú mismo.",
    nudge_later: "Más tarde",
    nudge_save: "Guardar",
    nudge_email_saved: "E-mail guardado",
    nudge_email_error: "E-mail inválido",
    nudge_temp_password: "Estás usando una contraseña temporal. Elige una nueva.",
    nudge_change_now: "Cambiar ahora",
    nav_preorder: "Reserva",
    status_preorder: "Reserva (próxima llegada)",
    product_preorder_badge: "Reserva",
    product_preorder_link: "Este producto llega pronto — resérvalo",
    preorder_kicker: "Próximas llegadas",
    preorder_title: "Reservas",
    preorder_subtitle: "Novedades y reposiciones esperadas de nuestros proveedores. Reserva ahora: se entregan al recibirlas, en la fecha indicada.",
    preorder_empty: "No hay reservas disponibles por ahora. ¡Vuelve pronto!",
    preorder_expected: "Llegada prevista el",
    preorder_available: "{count} unidad(es) disponibles",
    preorder_sold_out: "Agotado",
    preorder_items: "{count} artículo(s)",
    preorder_continue: "Reservar",
    preorder_login_required: "Inicia sesión para confirmar tu reserva.",
    preorder_back: "Volver",
    preorder_submit: "Enviar mi reserva",
    preorder_summary: "Tu reserva",
    preorder_delivery_note: "Entrega prevista a partir del {date}, al recibir la mercancía. Sin pago ahora.",
    preorder_error: "No se pudo guardar la reserva.",
    preorder_success_title: "Reserva registrada",
    preorder_success_text: "Tu reserva #{ref} está registrada. Te avisaremos cuando lleguen los productos.",
    preorder_whatsapp: "Confirmar en WhatsApp",
    nav_home: "Inicio",
    nav_catalogue: "Catálogo",
    nav_orders: "Pedidos",
    nav_admin: "Admin",
    nav_login: "Iniciar sesión",
    nav_my_account: "Mi Cuenta",
    nav_logout: "Cerrar sesión",
    nav_favorites: "Favoritos",
    home_search_placeholder: "Buscar un producto o código EAN...",
    home_browse_catalogue: "Ver catálogo completo",
    home_new_arrivals: "Novedades",
    home_back_in_stock: "De vuelta en stock",
    home_weekly_picks: "Favoritos de la semana",
    home_bestsellers: "Más vendidos",
    home_selection: "Selección",
    home_view_all: "Ver todo",
    banner_discover: "Descubrir",
    home_load_error: "No se pudieron cargar los productos",
    home_retry: "Reintentar",
    catalogue_title: "Nuestros Perfumes",
    catalogue_collection: "Colección",
    catalogue_search_placeholder: "Buscar por nombre, marca o código EAN...",
    catalogue_search_btn: "Buscar",
    catalogue_filters: "Filtros",
    catalogue_clear: "Limpiar",
    catalogue_categories: "Categorías",
    catalogue_brands: "Marcas",
    catalogue_all: "Todas",
    catalogue_price: "Precio (€)",
    catalogue_in_stock_only: "Solo en stock",
    catalogue_sort_by: "Ordenar por",
    catalogue_sort_newest: "Más recientes",
    catalogue_sort_oldest: "Más antiguos",
    catalogue_sort_price_asc: "Precio ascendente",
    catalogue_sort_price_desc: "Precio descendente",
    catalogue_sort_name_asc: "Nombre A-Z",
    catalogue_sort_name_desc: "Nombre Z-A",
    catalogue_products_count: "{count} producto{plural}",
    catalogue_no_results: "Ningún producto coincide con tus criterios.",
    catalogue_clear_filters: "Limpiar filtros",
    product_out_of_stock: "Agotado",
    product_last_pieces: "Últimas unidades",
    product_added_to_cart: "{name} añadido al carrito",
    product_login_for_favorites: "Inicia sesión para añadir a favoritos",
    product_from: "desde",
    product_pro: "Pro",
    cart_title: "Carrito",
    cart_your_selection: "Tu Selección",
    cart_empty: "Tu carrito está vacío",
    cart_empty_desc: "Descubre nuestra colección de perfumes",
    cart_view_catalogue: "Ver catálogo",
    cart_clear: "Vaciar carrito",
    cart_summary: "Resumen",
    cart_promo_label: "Código promocional",
    cart_promo_placeholder: "Introduce tu código",
    cart_promo_apply: "Aplicar",
    cart_subtotal: "Subtotal",
    cart_discount: "Descuento",
    cart_total: "Total",
    cart_checkout: "Hacer pedido",
    cart_continue_shopping: "Seguir comprando",
    cart_semi_gros_unlock: "¡Precios semi-mayorista disponibles!",
    cart_semi_gros_remaining: "Añade {count} perfume(s) más para desbloquear precios semi-mayorista.",
    cart_semi_gros_active: "¡Precios semi-mayorista activos! Disfrutas de tarifas profesionales.",
    cart_gros_unlock: "¡Accede a los precios al por mayor!",
    cart_gros_remaining: "Añade {count} perfume(s) más para desbloquear los mejores precios.",
    cart_gros_active: "¡Precios al por mayor activos! Disfrutas de las mejores tarifas.",
    checkout_title: "Pedir por WhatsApp",
    checkout_finalize: "Finalización",
    checkout_name: "Nombre completo",
    checkout_phone: "Teléfono",
    checkout_address: "Dirección de entrega",
    checkout_notes: "Notas (opcional)",
    checkout_notes_placeholder: "Instrucciones especiales...",
    checkout_order_btn: "Pedir por WhatsApp",
    checkout_processing: "Procesando...",
    checkout_your_order: "Tu pedido",
    checkout_info: "Al hacer clic en \"Pedir por WhatsApp\", serás redirigido a WhatsApp con un mensaje prellenado con tu pedido.",
    login_title: "Iniciar sesión",
    login_phone: "Número de teléfono",
    login_identifier: "Teléfono o email",
    login_password: "Contraseña",
    login_submit: "Iniciar sesión",
    login_loading: "Iniciando sesión...",
    login_no_account: "¿Aún no tienes cuenta?",
    login_register: "Registrarse",
    login_forgot: "¿Olvidaste tu contraseña?",
    login_error: "Credenciales incorrectas",
    register_title: "Crear una cuenta",
    register_name: "Nombre completo",
    register_phone: "Número de teléfono",
    register_email: "Email (opcional)",
    register_email_hint: "Para recibir nuestras ofertas y promociones",
    register_password: "Contraseña",
    register_confirm_password: "Confirmar contraseña",
    register_submit: "Crear mi cuenta",
    register_loading: "Creando...",
    register_has_account: "¿Ya tienes una cuenta?",
    register_login: "Iniciar sesión",
    register_password_mismatch: "Las contraseñas no coinciden",
    forgot_title: "Contraseña olvidada",
    forgot_phone: "Número de teléfono",
    forgot_whatsapp_btn: "Enviar por WhatsApp",
    forgot_sent_title: "Solicitud enviada",
    forgot_sent_desc: "Tu solicitud de restablecimiento de contraseña ha sido enviada por WhatsApp. Nuestro equipo procesará tu solicitud.",
    forgot_sent_delay: "Tiempo de procesamiento habitual: unos minutos durante el horario de atención.",
    forgot_back_login: "Volver al inicio de sesión",
    forgot_whatsapp_msg: "Hola, me gustaría restablecer mi contraseña.\n\nMi número: {phone}\n\nGracias.",
    account_title: "Mi Cuenta",
    account_orders: "Mis pedidos",
    account_order_history: "Historial de pedidos",
    account_no_orders: "Aún no hay pedidos",
    account_discover: "Descubre nuestros perfumes",
    account_order_prefix: "Pedido",
    account_ordered: "pedido",
    account_partial: "parcial",
    account_unavailable: "no disponible",
    account_note: "Nota",
    favorites_title: "Mis Favoritos",
    favorites_count: "{count} perfume{plural} guardado{plural}",
    favorites_empty: "Aún no hay favoritos",
    favorites_empty_desc: "Explora el catálogo y añade tus perfumes favoritos",
    favorites_browse: "Ver catálogo",
    confirmation_title: "¡Gracias por tu pedido!",
    confirmation_desc: "Tu pedido ha sido enviado por WhatsApp. Nuestro equipo te contactará pronto.",
    confirmation_back: "Volver al inicio",
    footer_desc: "Tu destino para perfumes de lujo. Descubre nuestra colección exclusiva de fragancias refinadas, disponibles al por menor, semi-mayorista y al por mayor.",
    footer_navigation: "Navegación",
    footer_contact: "Contacto",
    footer_rights: "Todos los derechos reservados.",
    footer_luxury: "Perfumes de Lujo",
    footer_shipping: "Envío Bélgica",
    status_pending: "Pendiente",
    status_confirmed: "Lista — pendiente de pago",
    status_ready: "Lista — pendiente de pago",
    status_processing: "En preparación",
    status_shipped: "Enviado",
    status_delivered: "Entregado",
    status_cancelled: "Cancelado",
    loading: "Cargando...",
    detail: "detalle",
    product_back_catalogue: "Volver al catálogo",
    product_not_found: "Producto no encontrado",
    product_in_stock: "En stock ({count} disponibles)",
    product_out_of_stock_full: "Agotado",
    product_retail_price: "Precio detalle",
    product_pro_prices: "Precios semi-mayorista y mayorista",
    product_register_pro: "Regístrate para acceder a precios profesionales",
    product_quantity: "Cantidad",
    product_add_to_cart: "Añadir al carrito",
    product_added: "Añadido",
    product_unit: "unidad",
    tier_detail: "Detalle",
    tier_semi_wholesale: "Semi-mayorista",
    tier_wholesale: "Mayorista",
    tier_unit_price: "Precio unitario",
    tier_from_units: "A partir de {count} unidades",
    tier_price_by_qty: "Precio por cantidad",
    tier_current_price: "Precio unitario actual",
    change_pwd_title: "Cambiar contraseña",
    change_pwd_current: "Contraseña actual",
    change_pwd_new: "Nueva contraseña",
    change_pwd_confirm: "Confirmar nueva contraseña",
    change_pwd_save: "Cambiar",
    change_pwd_success: "Contraseña cambiada con éxito",
    register_network_error: "Error de conexión. Verifique su red e intente nuevamente.",
    register_generic_error: "Ocurrió un error. Por favor, inténtelo de nuevo.",
    register_received: "Registro recibido",
    register_pending_msg: "Tu cuenta está pendiente de aprobación por el administrador. Recibirás acceso una vez aprobada.",
    auth_google_continue: "Continuar con Google",
    auth_or: "o",
    google_phone_title: "Casi listo",
    google_phone_msg: "Indica tu número de WhatsApp para completar tu registro. Tu cuenta será verificada por el administrador.",
    register_back_login: "Volver al inicio de sesión",
    register_email_label: "Dirección de email",
    register_email_optional: "Opcional — para recibir nuestras ofertas",
    account_hello: "Hola, {name}",
    favorites_login_title: "Tus Favoritos",
    favorites_login_desc: "Inicia sesión para ver tus productos favoritos",
    favorites_login_btn: "Iniciar sesión",
    favorites_saved: "Productos Favoritos",
    favorites_empty_tap: "Toca el corazón para guardar tus productos favoritos",
    favorites_others: "+{count} más",
    min: "Mín",
    max: "Máx",
  },

  de: {
    home_promos: "Aktuelle Aktionen",
    catalogue_promo_only: "Nur Aktionen",
    promo_until: "Bis {date}",
    forgot_admin_desc_failed: "Die E-Mail konnte nicht gesendet werden: unser Team wurde informiert und sendet Ihnen ein temporäres Passwort per WhatsApp. Sie können uns auch direkt schreiben:",
    login_remember: "30 Tage angemeldet bleiben",
    register_email_required: "Pflichtfeld — zur Wiederherstellung Ihres Kontos bei vergessenem Passwort",
    forgot_desc: "Telefonnummer oder E-Mail eingeben. Ist eine E-Mail hinterlegt, erhalten Sie einen Link; sonst sendet Ihnen unser Team ein temporäres Passwort per WhatsApp.",
    forgot_identifier: "Telefon oder E-Mail",
    forgot_submit: "Konto wiederherstellen",
    forgot_error: "Anfrage fehlgeschlagen, bitte erneut versuchen.",
    forgot_email_title: "E-Mail gesendet",
    forgot_email_desc: "Ein Link wurde an {email} gesendet. Gültig für 1 Stunde.",
    forgot_email_hint: "Prüfen Sie auch Ihren Spam-Ordner.",
    forgot_admin_title: "Anfrage erhalten",
    forgot_admin_desc: "Keine E-Mail hinterlegt: unser Team wurde informiert und sendet Ihnen ein temporäres Passwort per WhatsApp. Sie können uns auch direkt schreiben:",
    forgot_none_title: "Konto nicht gefunden",
    forgot_none_desc: "Kein Konto mit dieser Kennung gefunden. Kontaktieren Sie uns per WhatsApp.",
    reset_title: "Neues Passwort",
    reset_desc: "Wählen Sie ein neues Passwort (mind. 6 Zeichen).",
    reset_new_password: "Neues Passwort",
    reset_confirm_password: "Passwort bestätigen",
    reset_submit: "Speichern",
    reset_mismatch: "Passwörter stimmen nicht überein",
    reset_error: "Ungültiger oder abgelaufener Link",
    reset_invalid: "Dieser Link ist ungültig. Fordern Sie einen neuen über „Passwort vergessen“ an.",
    reset_done_title: "Passwort geändert",
    reset_done_desc: "Sie können sich jetzt anmelden. Weiterleitung…",
    nudge_email_title: "Konto absichern",
    nudge_email_desc: "Fügen Sie Ihre E-Mail hinzu, um Ihr Konto selbst wiederherstellen zu können.",
    nudge_later: "Später",
    nudge_save: "Speichern",
    nudge_email_saved: "E-Mail gespeichert",
    nudge_email_error: "Ungültige E-Mail-Adresse",
    nudge_temp_password: "Sie verwenden ein temporäres Passwort. Wählen Sie ein neues.",
    nudge_change_now: "Jetzt ändern",
    nav_preorder: "Vorbestellung",
    status_preorder: "Vorbestellung (in Anlieferung)",
    product_preorder_badge: "Vorbestellung",
    product_preorder_link: "Dieses Produkt kommt bald — jetzt vorbestellen",
    preorder_kicker: "Kommende Lieferungen",
    preorder_title: "Vorbestellungen",
    preorder_subtitle: "Neuheiten und Nachlieferungen unserer Lieferanten. Jetzt reservieren: Lieferung sofort nach Eingang zum angegebenen Datum.",
    preorder_empty: "Derzeit keine Vorbestellungen. Bald wieder vorbeischauen!",
    preorder_expected: "Erwartet am",
    preorder_available: "{count} Stück verfügbar",
    preorder_sold_out: "Ausverkauft",
    preorder_items: "{count} Artikel",
    preorder_continue: "Vorbestellen",
    preorder_login_required: "Bitte anmelden, um die Vorbestellung zu bestätigen.",
    preorder_back: "Zurück",
    preorder_submit: "Vorbestellung senden",
    preorder_summary: "Ihre Vorbestellung",
    preorder_delivery_note: "Lieferung voraussichtlich ab {date}, sobald die Ware eintrifft. Keine Zahlung jetzt.",
    preorder_error: "Die Vorbestellung konnte nicht gespeichert werden.",
    preorder_success_title: "Vorbestellung gespeichert",
    preorder_success_text: "Ihre Vorbestellung #{ref} ist gespeichert. Wir informieren Sie bei Ankunft.",
    preorder_whatsapp: "Per WhatsApp bestätigen",
    nav_home: "Startseite",
    nav_catalogue: "Katalog",
    nav_orders: "Bestellungen",
    nav_admin: "Admin",
    nav_login: "Anmelden",
    nav_my_account: "Mein Konto",
    nav_logout: "Abmelden",
    nav_favorites: "Favoriten",
    home_search_placeholder: "Produkt oder EAN-Code suchen...",
    home_browse_catalogue: "Gesamten Katalog durchsuchen",
    home_new_arrivals: "Neuheiten",
    home_back_in_stock: "Wieder auf Lager",
    home_weekly_picks: "Lieblinge der Woche",
    home_bestsellers: "Bestseller",
    home_selection: "Auswahl",
    home_view_all: "Alle ansehen",
    banner_discover: "Entdecken",
    home_load_error: "Produkte konnten nicht geladen werden",
    home_retry: "Erneut versuchen",
    catalogue_title: "Unsere Parfums",
    catalogue_collection: "Kollektion",
    catalogue_search_placeholder: "Nach Name, Marke oder EAN-Code suchen...",
    catalogue_search_btn: "Suchen",
    catalogue_filters: "Filter",
    catalogue_clear: "Löschen",
    catalogue_categories: "Kategorien",
    catalogue_brands: "Marken",
    catalogue_all: "Alle",
    catalogue_price: "Preis (€)",
    catalogue_in_stock_only: "Nur auf Lager",
    catalogue_sort_by: "Sortieren nach",
    catalogue_sort_newest: "Neueste",
    catalogue_sort_oldest: "Älteste",
    catalogue_sort_price_asc: "Preis aufsteigend",
    catalogue_sort_price_desc: "Preis absteigend",
    catalogue_sort_name_asc: "Name A-Z",
    catalogue_sort_name_desc: "Name Z-A",
    catalogue_products_count: "{count} Produkt{plural}",
    catalogue_no_results: "Keine Produkte entsprechen Ihren Kriterien.",
    catalogue_clear_filters: "Filter löschen",
    product_out_of_stock: "Ausverkauft",
    product_last_pieces: "Letzte Stücke",
    product_added_to_cart: "{name} zum Warenkorb hinzugefügt",
    product_login_for_favorites: "Melden Sie sich an, um Favoriten hinzuzufügen",
    product_from: "ab",
    product_pro: "Pro",
    cart_title: "Warenkorb",
    cart_your_selection: "Ihre Auswahl",
    cart_empty: "Ihr Warenkorb ist leer",
    cart_empty_desc: "Entdecken Sie unsere Parfumkollektion",
    cart_view_catalogue: "Katalog ansehen",
    cart_clear: "Warenkorb leeren",
    cart_summary: "Zusammenfassung",
    cart_promo_label: "Promo-Code",
    cart_promo_placeholder: "Code eingeben",
    cart_promo_apply: "Anwenden",
    cart_subtotal: "Zwischensumme",
    cart_discount: "Rabatt",
    cart_total: "Gesamt",
    cart_checkout: "Bestellung aufgeben",
    cart_continue_shopping: "Weiter einkaufen",
    cart_semi_gros_unlock: "Halbgroßhandelspreise verfügbar!",
    cart_semi_gros_remaining: "Fügen Sie noch {count} Parfum(s) hinzu, um Halbgroßhandelspreise freizuschalten.",
    cart_semi_gros_active: "Halbgroßhandelspreise aktiv! Sie profitieren von professionellen Tarifen.",
    cart_gros_unlock: "Wechseln Sie zu Großhandelspreisen!",
    cart_gros_remaining: "Fügen Sie noch {count} Parfum(s) hinzu für die besten Preise.",
    cart_gros_active: "Großhandelspreise aktiv! Sie profitieren von den besten Tarifen.",
    checkout_title: "Per WhatsApp bestellen",
    checkout_finalize: "Bestellung abschließen",
    checkout_name: "Vollständiger Name",
    checkout_phone: "Telefon",
    checkout_address: "Lieferadresse",
    checkout_notes: "Anmerkungen (optional)",
    checkout_notes_placeholder: "Besondere Anweisungen...",
    checkout_order_btn: "Per WhatsApp bestellen",
    checkout_processing: "Verarbeitung...",
    checkout_your_order: "Ihre Bestellung",
    checkout_info: "Mit Klick auf \"Per WhatsApp bestellen\" werden Sie zu WhatsApp weitergeleitet mit einer vorausgefüllten Nachricht Ihrer Bestellung.",
    login_title: "Anmelden",
    login_phone: "Telefonnummer",
    login_identifier: "Telefon oder E-Mail",
    login_password: "Passwort",
    login_submit: "Anmelden",
    login_loading: "Anmelden...",
    login_no_account: "Noch kein Konto?",
    login_register: "Registrieren",
    login_forgot: "Passwort vergessen?",
    login_error: "Ungültige Anmeldedaten",
    register_title: "Konto erstellen",
    register_name: "Vollständiger Name",
    register_phone: "Telefonnummer",
    register_email: "E-Mail (optional)",
    register_email_hint: "Um unsere Angebote zu erhalten",
    register_password: "Passwort",
    register_confirm_password: "Passwort bestätigen",
    register_submit: "Konto erstellen",
    register_loading: "Erstellen...",
    register_has_account: "Bereits ein Konto?",
    register_login: "Anmelden",
    register_password_mismatch: "Passwörter stimmen nicht überein",
    forgot_title: "Passwort vergessen",
    forgot_phone: "Telefonnummer",
    forgot_whatsapp_btn: "Per WhatsApp senden",
    forgot_sent_title: "Anfrage gesendet",
    forgot_sent_desc: "Ihre Anfrage zur Passwortrücksetzung wurde per WhatsApp gesendet. Unser Team wird Ihre Anfrage bearbeiten.",
    forgot_sent_delay: "Übliche Bearbeitungszeit: einige Minuten während der Geschäftszeiten.",
    forgot_back_login: "Zurück zur Anmeldung",
    forgot_whatsapp_msg: "Hallo, ich möchte mein Passwort zurücksetzen.\n\nMeine Nummer: {phone}\n\nVielen Dank.",
    account_title: "Mein Konto",
    account_orders: "Meine Bestellungen",
    account_order_history: "Bestellverlauf",
    account_no_orders: "Noch keine Bestellungen",
    account_discover: "Entdecken Sie unsere Parfums",
    account_order_prefix: "Bestellung",
    account_ordered: "bestellt",
    account_partial: "teilweise",
    account_unavailable: "nicht verfügbar",
    account_note: "Hinweis",
    favorites_title: "Meine Favoriten",
    favorites_count: "{count} Parfum{plural} gespeichert",
    favorites_empty: "Noch keine Favoriten",
    favorites_empty_desc: "Durchsuchen Sie den Katalog und fügen Sie Ihre Lieblingsparfums hinzu",
    favorites_browse: "Katalog ansehen",
    confirmation_title: "Vielen Dank für Ihre Bestellung!",
    confirmation_desc: "Ihre Bestellung wurde per WhatsApp gesendet. Unser Team wird sich in Kürze bei Ihnen melden.",
    confirmation_back: "Zurück zur Startseite",
    footer_desc: "Ihr Ziel für Luxusparfums. Entdecken Sie unsere exklusive Kollektion raffinierter Düfte, erhältlich im Einzelhandel, Halbgroßhandel und Großhandel.",
    footer_navigation: "Navigation",
    footer_contact: "Kontakt",
    footer_rights: "Alle Rechte vorbehalten.",
    footer_luxury: "Luxus-Parfums",
    footer_shipping: "Lieferung Belgien",
    status_pending: "Ausstehend",
    status_confirmed: "Fertig — Zahlung ausstehend",
    status_ready: "Fertig — Zahlung ausstehend",
    status_processing: "In Bearbeitung",
    status_shipped: "Versendet",
    status_delivered: "Zugestellt",
    status_cancelled: "Storniert",
    loading: "Laden...",
    detail: "Einzelhandel",
    product_back_catalogue: "Zurück zum Katalog",
    product_not_found: "Produkt nicht gefunden",
    product_in_stock: "Auf Lager ({count} verfügbar)",
    product_out_of_stock_full: "Ausverkauft",
    product_retail_price: "Einzelhandelspreis",
    product_pro_prices: "Halbgroßhandels- & Großhandelspreise",
    product_register_pro: "Registrieren Sie sich für professionelle Preise",
    product_quantity: "Menge",
    product_add_to_cart: "In den Warenkorb",
    product_added: "Hinzugefügt",
    product_unit: "Stück",
    tier_detail: "Einzelhandel",
    tier_semi_wholesale: "Halbgroßhandel",
    tier_wholesale: "Großhandel",
    tier_unit_price: "Stückpreis",
    tier_from_units: "Ab {count} Stück",
    tier_price_by_qty: "Preis nach Menge",
    tier_current_price: "Aktueller Stückpreis",
    change_pwd_title: "Passwort ändern",
    change_pwd_current: "Aktuelles Passwort",
    change_pwd_new: "Neues Passwort",
    change_pwd_confirm: "Neues Passwort bestätigen",
    change_pwd_save: "Ändern",
    change_pwd_success: "Passwort erfolgreich geändert",
    register_network_error: "Verbindungsfehler. Überprüfen Sie Ihr Netzwerk und versuchen Sie es erneut.",
    register_generic_error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    register_received: "Registrierung eingegangen",
    register_pending_msg: "Ihr Konto wartet auf Genehmigung durch den Administrator. Sie erhalten Zugang nach der Genehmigung.",
    auth_google_continue: "Mit Google fortfahren",
    auth_or: "oder",
    google_phone_title: "Fast geschafft",
    google_phone_msg: "Geben Sie Ihre WhatsApp-Nummer an, um die Registrierung abzuschließen. Ihr Konto wird anschließend vom Administrator geprüft.",
    register_back_login: "Zurück zur Anmeldung",
    register_email_label: "E-Mail-Adresse",
    register_email_optional: "Optional — um unsere Angebote zu erhalten",
    account_hello: "Hallo, {name}",
    favorites_login_title: "Ihre Favoriten",
    favorites_login_desc: "Melden Sie sich an, um Ihre Lieblingsprodukte zu sehen",
    favorites_login_btn: "Anmelden",
    favorites_saved: "Lieblingsprodukte",
    favorites_empty_tap: "Tippen Sie auf das Herz, um Ihre Lieblingsprodukte zu speichern",
    favorites_others: "+{count} mehr",
    min: "Min",
    max: "Max",
  },
};

export const LANGUAGES = [
  { code: 'fr', label: 'FR', flag: '🇫🇷', name: 'Français' },
  { code: 'en', label: 'EN', flag: '🇬🇧', name: 'English' },
  { code: 'nl', label: 'NL', flag: '🇳🇱', name: 'Nederlands' },
  { code: 'es', label: 'ES', flag: '🇪🇸', name: 'Español' },
  { code: 'de', label: 'DE', flag: '🇩🇪', name: 'Deutsch' },
  { code: 'ar', label: 'AR', flag: '🇸🇦', name: 'العربية' },
];

export default translations;
